import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  width: 255px;
  flex-direction: column;
`;

export const Label = styled.span`
  color: #7b7b7b;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  margin-bottom: 6px;
`;

export const Input = styled.input.attrs((props) => ({
  ref: props.ref,
  type: props.type,
  pattern: props.pattern,
}))`
  -webkit-appearance: none;
  height: ${(props) => props.height || '32px'};
  padding: 0 12px;
  background-color: #fff;
  border: 1px solid ${(props) => (props.error ? '#F27160' : '#ebebeb')};
  border-radius: 3px;
  color: #7b7b7b;
  font-size: 12px;
  font-weight: 400;
  font-family: 'Montserrat', sans-serif;
  width: ${(props) => (props.width ? props.width : '100%')};
  min-width: ${(props) => (props.minWidth ? props.minWidth : '100%')};

  ${(props) => props.error && 'box-shadow: 0 3px 6px #f2716044;'}

  ::placeholder {
    font-weight: 400;
  }

  transition: 200ms;
`;
